import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
} from "@mui/material";
import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "../process/process.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import moment from "moment";
import Label from "../../../components/Label/Label";
import { useSelector } from "react-redux";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  handleAddLimit,
  openData,
}) {
  const [openRow, setOpenRow] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState({ anchorEl: null, rowId: null });
  const { unitOfOperation } = useSelector(
    (state) => state.shared?.productSitesUopValues || {}
  );
  const handleClick = (event, rowId) => {
    if (rowId) setMenuAnchor({ anchorEl: event.currentTarget, rowId });
  };

  const handleClose = () => {
    setMenuAnchor({ anchorEl: null, rowId: null });
  };
  const [expandedSections, setExpandedSections] = useState({});
  const isMenuOpen = menuAnchor.anchorEl !== null;

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const handleAdd = (id) => {
    handleClose();
    handleAddLimit();
  };

  const toggleSection = (rowId, section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [section]: !prev[rowId]?.[section],
      },
    }));
  };

  const groupByTableAndPhase = (results) => {
    return results?.reduce((acc, row) => {
      const tableName = row.table_level || "";
      const phase = row.phase || "";

      if (!acc[tableName]) acc[tableName] = {};
      if (!acc[tableName][phase]) acc[tableName][phase] = [];

      acc[tableName][phase].push(row);
      return acc;
    }, {});
  };

  const formatValues = (
    lowerValue,
    upperValue,
    lowerLabel,
    upperLabel,
    bothLabel
  ) => {
    if (lowerValue || upperValue) {
      return `${bothLabel}: (${lowerValue ?? ''}${lowerValue != null && upperValue != null ? ', ' : ''}${upperValue ?? ''})`;
    }
    return "";
    // if (lowerValue && upperValue) {
    //   return `${bothLabel}: (${lowerValue}, ${upperValue})`;
    // }
    // if (lowerValue) {
    //   return `${lowerLabel}: (${lowerValue})`;
    // }
    // if (upperValue) {
    //   return `${upperLabel}: (${upperValue})`;
    // }

  };


  const renderExpandableSection = (row, sectionLabel, primaryROw) => {
    const sectionKey = sectionLabel.toLowerCase();
    const isOpen = expandedSections[row?.parameter_id]?.[sectionKey];
    return (
      <>
        {isOpen && (
          <TableRow sx={{ background: "#F5F5F5" }}>
            <TableCell />
            <TableCell>{primaryROw.label + (primaryROw.unit_of_measure ? (` (${primaryROw.unit_of_measure})`) : "")}</TableCell>
            {/* <TableCell>{primaryROw.unit_of_measure}</TableCell> */}
            <TableCell sx={{ minWidth: "350px" }}>
              {sectionKey === "specification" && (
                <>
                  <div> {(row?.acceptable_value && /[^\s{}"]/.test(row.acceptable_value)) &&
                    ("Acceptable Values: " + row.acceptable_value.replace(/[{}"]/g, ''))
                  }{' '}
                  </div>
                  <div>{row?.spec_name && `${row?.spec_name} `}
                    {
                      row?.lower_limit_type != null &&
                        row?.lower_spec != null &&
                        row?.upper_limit_type != null &&
                        row?.upper_spec != null
                        ? // both present
                        `${row.lower_limit_type} ${row.lower_spec} And ${row.upper_limit_type} ${row.upper_spec}`
                        : row?.lower_limit_type != null &&
                          row?.lower_spec != null
                          ? // only lower
                          `${row.lower_limit_type} ${row.lower_spec}`
                          : row?.upper_limit_type != null &&
                            row?.upper_spec != null
                            ? // only upper
                            `${row.upper_limit_type} ${row.upper_spec}`
                            : "" // none
                    }{" "}
                    {row?.process_target && (
                      <span
                        style={{ backgroundColor: "#C9F6CF", padding: "5px" }}
                      >
                        Process Target: {row.process_target}
                      </span>
                    )}</div>
                </>
              )}
              {sectionKey === "control" && (
                <>
                  <div>  {formatValues(
                    row?.lt_std_dev,
                    row?.st_std_dev,
                    "Lt Std Dev",
                    "St Std Dev",
                    "Std Dev"
                  )}{" "}</div>
                  <div>
                    {formatValues(
                      row?.lower_control,
                      row?.upper_control,
                      "Lower CL",
                      "Upper CL",
                      "CL"
                    )}{" "}
                  </div>
                  <div>
                    {formatValues(
                      row?.lower_warning,
                      row?.upper_warning,
                      "Lower WL",
                      "Upper WL",
                      "WL"
                    )}{' '}</div>
                  <div> {formatValues(
                    row?.lil,
                    row?.uil,
                    "LIL",
                    "UIL",
                    "IL"
                  )}</div>
                  <div> {formatValues(
                    row?.cp,
                    row?.cpl,
                    "Cp",
                    "Cpl",
                    "Cp/Cpl"
                  )}</div>
                  <div> {formatValues(
                    row?.cpu,
                    row?.cpk,
                    "Cpu",
                    "Cpk",
                    "Cpu/Cpk"
                  )}</div>
                  <div> {formatValues(
                    row?.pp,
                    row?.ppl,
                    "Pp",
                    "Ppl",
                    "Pp/Ppl"
                  )}</div>
                  <div> {formatValues(
                    row?.ppu,
                    row?.ppk,
                    "Ppu",
                    "Ppk",
                    "Ppu/Ppk"
                  )}</div>
                  {/* {row.lower_warning && 'WL :' + row.lower_warning} */}
                  {row.target_mean !== null && `Mean: ${row.target_mean}`}
                </>
              )}
              {sectionKey === "target" && (
                <>{row.process_target && `Target ${row.process_target} `}</>
              )}
            </TableCell>

            <TableCell sx={{ minWidth: "110px" }}>
              {" "}
              <Chip
                label={row.status}
                className={`status-chip ${row.status?.includes("Current") ? "status-chip-color-green" : "status-chip-color-gray"}`}
              />
            </TableCell>
            <TableCell> {row.set_id}</TableCell>
            <TableCell sx={{ minWidth: "106px" }}>
              {row.valid_from}
              {/* {moment(row.valid_from).isValid()
                ? moment(row.valid_from).format("DD-MMM-YYYY")
                : ""} */}
            </TableCell>
            {/* <TableCell>-</TableCell> */}

            {/* <TableCell></TableCell> */}
            <TableCell
              sx={{
                minWidth: "95px",
                textAlign: 'center'
              }}
            >
              <IconButton
                size="small"
                onClick={() => onView(row, primaryROw, sectionKey)}
              >
                <VisibilityIcon sx={{ color: "#717680" }} />
              </IconButton>
              {/* <IconButton
                size="small"
                onClick={() => console.log("More clicked")}
              >
                <MoreHorizIcon />
              </IconButton> */}
            </TableCell>
          </TableRow>
        )}
      </>
    );
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        className="limit-parameter-table-container"
        sx={{ scrollbarGutter: "stable" }}
      >
        <Table stickyHeader sx={{ tableLayout: "auto", width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell className="table-header-cell" sx={{ width: "40px" }}>
                {/* Expand button column */}
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{ minWidth: "150px" }}
              >
                Parameter Name
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{ minWidth: "350px" }}
              >
                Values
              </TableCell>
              <TableCell className="table-header-cell" sx={{ width: "120px", paddingLeft: '40px !important' }}>
                Status
              </TableCell>
              <TableCell className="table-header-cell" sx={{ width: "100px" }}>
                Set
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{ minWidth: "120px" }}
              >
                Valid From
              </TableCell>
              <TableCell className="table-header-cell" sx={{ width: "100px", textAlign: 'center' }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {(() => {
              const groupedData = groupByTableAndPhase(
                data?.data?.results || []
              );

              return Object.entries(groupedData || {}).map(
                ([tableName, phases]) => (
                  <React.Fragment key={tableName}>
                    {/* Table Name Header */}
                    {tableName && (
                      <TableRow
                        sx={{
                          backgroundColor: "#e6ebf2",
                          height: "16px !important",
                        }}
                      >
                        <TableCell
                          colSpan={tableHeaders?.length || 7}
                          sx={{ fontWeight: "bold", fontSize: 15 }}
                        >
                          {tableName}
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Phase groups inside each table */}
                    {Object.entries(phases).map(([phase, rows]) => (
                      <React.Fragment key={`${tableName}-${phase}`}>
                        {phase && (
                          <TableRow
                            sx={{
                              backgroundColor: "#f0f2f5",
                              height: "12px !important",
                            }}
                          >
                            <TableCell
                              colSpan={tableHeaders?.length || 7}
                              sx={{ fontWeight: "bold", fontSize: 14 }}
                            >
                              Phase- {phase}
                            </TableCell>
                          </TableRow>
                        )}

                        {/* Parameters under this phase */}
                        {rows?.map((row) => (
                          <React.Fragment key={row?.parameter_id}>
                            <TableRow>
                              <TableCell>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    toggleExpand(row?.parameter_id)
                                  }
                                >
                                  {openRow === row?.parameter_id ? (
                                    <KeyboardArrowUpIcon
                                      sx={{ fontSize: 32 }}
                                    />
                                  ) : (
                                    <KeyboardArrowDownIcon
                                      sx={{ fontSize: 32 }}
                                    />
                                  )}
                                </IconButton>
                              </TableCell>

                              <TableCell sx={{ textTransform: "none" }}>
                                <Label textTransform="none" text={row.label + (row.unit_of_measure ? (` (${row.unit_of_measure})`) : "")} />
                              </TableCell>

                              <TableCell sx={{ fontSize: 14 }}></TableCell>

                              <TableCell sx={{ fontSize: 14 }}>
                                <Chip
                                  label={row.status}
                                  className={`status-chip ${row.status?.includes("active")
                                    ? "status-chip-color-green"
                                    : "status-chip-color-gray"
                                    }`}
                                />
                              </TableCell>

                              <TableCell sx={{ fontSize: 14 }}></TableCell>
                              <TableCell sx={{ fontSize: 14 }}></TableCell>
                              <TableCell />
                            </TableRow>

                            {/* Expanded Sections */}
                            {openRow === row?.parameter_id && (
                              <>
                                {/* Control Section */}
                                <TableRow sx={{ backgroundColor: "#D5D7DA" }}>
                                  <TableCell sx={{ width: "70px" }}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      sx={{ pl: 2 }}
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          toggleSection(
                                            row?.parameter_id,
                                            "control"
                                          )
                                        }
                                      >
                                        {expandedSections[row?.parameter_id]?.[
                                          "control"
                                        ] ? (
                                          <KeyboardArrowUpIcon
                                            sx={{ fontSize: 32 }}
                                          />
                                        ) : (
                                          <KeyboardArrowDownIcon
                                            sx={{ fontSize: 32 }}
                                          />
                                        )}
                                      </IconButton>
                                      Control
                                    </Box>
                                  </TableCell>
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                </TableRow>
                                {row?.control_limits?.map((ctrl, idx) =>
                                  renderExpandableSection(
                                    { ...ctrl, parameter_id: row.parameter_id },
                                    "Control",
                                    row
                                  )
                                )}

                                {/* Specification Section */}
                                <TableRow sx={{ backgroundColor: "#D5D7DA" }}>
                                  <TableCell sx={{ width: "70px" }}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      sx={{ pl: 2 }}
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          toggleSection(
                                            row?.parameter_id,
                                            "specification"
                                          )
                                        }
                                      >
                                        {expandedSections[row?.parameter_id]?.[
                                          "specification"
                                        ] ? (
                                          <KeyboardArrowUpIcon
                                            sx={{ fontSize: 32 }}
                                          />
                                        ) : (
                                          <KeyboardArrowDownIcon
                                            sx={{ fontSize: 32 }}
                                          />
                                        )}
                                      </IconButton>
                                      Specification
                                    </Box>
                                  </TableCell>
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                </TableRow>
                                {row?.specification_limit?.map((spec, idx) =>
                                  renderExpandableSection(
                                    { ...spec, parameter_id: row.parameter_id },
                                    "Specification",
                                    row
                                  )
                                )}
                              </>
                            )}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                )
              );
            })()}

            {/* Empty state */}
            {!data?.loader && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={tableHeaders?.length || 7} align="center">
                 {unitOfOperation?.id ? (
                    <Label color="textSecondary" text={"No data found"} />
                  ) : (
                    <Label color="textSecondary" text={"Select Unit Operation to view limits"} />
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
